import React from 'react';
import { Text, View } from "../../Components/Themed"
import { useColors } from '../../constants/useColors';

type AnalyticsCardProps = {
    label:string,
    value:number,
    value_label:string,
    success_limit:number
}

const AnalyticsCard = ({ label, value, success_limit, value_label }:AnalyticsCardProps) => {
    const Colors = useColors();
    const color = value >= success_limit ? Colors.text.success : Colors.text.error


    return (
        <View float>
            <View type='header' style={{ padding:8, borderTopRightRadius:8, borderTopLeftRadius:8}}>
                <Text theme='h2'>{label}</Text>
            </View>
            <View transparent style={{ flex:1, padding:15 }}>
                <Text theme='h1' color={color}>{value_label}</Text>
            </View>
        </View>
    )
}

export default AnalyticsCard